<template>
  <div>
    <div class="page-header">
      <div>
        <h2 class="main-content-title tx-24 mg-b-5">{{isCreate ? `Add ${page}` : `Edit ${page}`}}</h2>
        <ol class="breadcrumb">
          <li class="breadcrumb-item"><a href="#" @click="$router.go(-1)">Back</a></li>
          <li class="breadcrumb-item active" aria-current="page">{{isCreate ? `Add ${page}`  : `Edit ${page}`}}</li>
        </ol>
      </div>
      <div class="d-flex">
      </div>
    </div>
    <div class="row row-sm justify-content-center">
      <div class="col-xl-7 col-lg-8 col-md-12">
        <div class="card custom-card">
          <div class="card-body">
            <div>
              <h6 class="main-content-label mb-1">Page</h6>
            </div>
            <div v-if="showVideo === true">
              <ValidationObserver ref="currencyAddForm" id="hotelsAddForm" tag="form" class="d-flex flex-column" @submit.prevent="formSubmit()">
                <b-tabs content-class="mt-3">
                  <b-tab :title="language.code" v-for="(language, i) in languages" :key="i">
                    <ValidationProvider v-slot="{ classes }" rules="required" tag="div" class="form-group">
                      <label :for="'name[' + language.code + ']'" class="form-label">Title:</label>
                      <input :id="'name[' + language.code + ']'" class="form-control" :name="'title_l[' + language.code + ']'" v-model="formData.title_l[language.code]" :class="checkValidation(classes, language.code)" placeholder="title" type="text">
                    </ValidationProvider>
                    <div class="d-flex justify-content-between align-items-center">
                      <h4>House Rules</h4>
                      <button type="button" @click="addContent" class="btn ripple btn-main-primary mt-2">Add House Rules</button>
                    </div>
                    <div class="border-bottom mb-2 mt-3" v-for="(item, index) in formData.house_rules" :key="index">
                      <ValidationProvider v-slot="{ classes }" rules="required" tag="div" class="form-group">
                        <label :for="`house_rules[${index}].title[${language.code}]`" class="form-label d-flex justify-content-between align-items-center">
                          <span>Title:</span>
                          <button type="button" @click="removeContent(index)" class="btn ripple btn-main-primary radius" v-if="index > 0">
                            <i class="ti-close"></i>
                          </button>
                        </label>
                        <input :id="`house_rules[${index}].title[${language.code}]`" class="form-control" :name="`house_rules[${index}][title][${language.code}]`" v-model="formData.house_rules[index].title[language.code]" :class="checkValidation(classes, language.code)" placeholder="title" type="text">
                      </ValidationProvider>
                      <ValidationProvider v-slot="{ classes }" rules="required" tag="div" class="form-group">
                        <label :for="`house_rules[${index}].body[${language.code}]`" class="form-label">Body:</label>
                        <ckeditor :class="checkValidation(classes, language.code)" v-model="formData.house_rules[index].body[language.code]"   :name="`house_rules[${index}].body[${language.code}]`"  :id="`house_rules[${index}].body[${language.code}]`" :config="ckEditorConfig"></ckeditor>
                      </ValidationProvider>
                    </div>
                  </b-tab>
                  <ValidationProvider rules="" tag="div" v-slot="{ classes }" class="form-group">
                    <label for="external_code" class="form-label">External Code:</label>
                    <input id="external_code" class="form-control" name="external_code" v-model="formData.external_code" placeholder="external code" :class="classes" type="text">
                  </ValidationProvider>
                  <ValidationProvider rules="required" tag="div" v-slot="{ classes }" class="form-group">
                    <label for="fax" class="form-label">Fax:</label>
                    <input id="fax" class="form-control" name="fax" v-model="formData.fax" placeholder="fax" :class="classes" type="text">
                  </ValidationProvider>
                  <ValidationProvider rules="required" tag="div" v-slot="{ classes }" class="form-group">
                    <label for="phone" class="form-label">Phone:</label>
                    <input id="phone" class="form-control" name="phone" v-model="formData.phone" placeholder="phone" :class="classes" type="text">
                  </ValidationProvider>
                  <ValidationProvider rules="required" tag="div" v-slot="{ classes }" class="form-group">
                    <label for="giata_code" class="form-label">Giata code:</label>
                    <input id="giata_code" class="form-control" name="giata_code" v-model="formData.giata_code" placeholder="Giata code" :class="classes" type="text">
                  </ValidationProvider>
                  <ValidationProvider rules="required" tag="div" v-slot="{ classes }" class="form-group">
                    <label for="stars" class="form-label">Stars:</label>
                    <select id="stars" class="form-control" name="stars" v-model="formData.stars" :class="classes">
                      <option value="1">1</option>
                      <option value="2">2</option>
                      <option value="3">3</option>
                      <option value="4">4</option>
                      <option value="5">5</option>
                    </select>
                  </ValidationProvider>
                  <ValidationProvider rules="required" tag="div" v-slot="{ classes }" class="form-group">
                    <label for="continent_id" class="form-label">District:</label>
                    <multiselect v-model="formData.district" placeholder="Select district" id="continent_id" :custom-label="customLabel" :class="classes"  :close-on-select="true" track-by="id" :options="districts">
                      <template slot="singleLabel" slot-scope="props">
                        {{props.option.title_l[$i18n.locale]}}
                      </template>
                      <template slot="option" slot-scope="props">
                        <span class="option__name">{{props.option.title_l[$i18n.locale]}}</span>
                      </template>
                    </multiselect>
                  </ValidationProvider>
                  <ValidationProvider rules="required" tag="div" v-slot="{ classes }" class="form-group">
                    <label for="facilities_id" class="form-label">Facilities:</label>
                    <multiselect v-model="formData.facilities" placeholder="Select facilities" :multiple="true" id="facilities_id" :custom-label="customLabel" :class="classes"  :close-on-select="true" track-by="id" :options="facilities">
                      <template slot="singleLabel" slot-scope="props">
                        {{props.option.title_l[$i18n.locale]}}
                      </template>
                      <template slot="option" slot-scope="props">
                        <span class="option__name">{{props.option.title_l[$i18n.locale]}}</span>
                      </template>
                    </multiselect>
                  </ValidationProvider>
                  <ValidationProvider rules="required" tag="div" v-slot="{ classes }" class="d-flex align-items-center mb-3">
                    <label for="is_apartment" class="form-label">Is apartment:</label>
                    <input id="is_apartment" value='1' class="ml-5 wd-25 ht-25" name="is_apartment" v-model="formData.is_apartment" placeholder="title" :class="classes" type="checkbox">
                  </ValidationProvider>
                  <label class="form-label">
                    Address
                    <br/>
                    <gmap-autocomplete
                      ref="autocomplete"
                      :selectFirstOnEnter="true"
                      class="form-control"
                      :value="formData.address"
                      @place_changed="searchAddressDone">
                    </gmap-autocomplete>
                  </label>
                  <gmap-map
                    :center="map.center"
                    :zoom="map.zoom"
                    map-type-id="terrain"
                    style="width: 100%; height: 300px"
                  >
                    <gmap-marker
                      :position="map.center"
                      :clickable="true"
                      :draggable="true"
                      @dragend="dragendMapMarker"
                    />
                  </gmap-map>
                  <ImageUpload accept="image/png,image/jpeg,image/jpg" label="Image:" page="media" @set-multiple-file="(file) => multipleFiles.push(file)" @hide-multiple-file="(id) => multipleFiles = multipleFiles.filter(item =>  item.multipleId !== id)" :isMultiple="true" name="" uploadType="images" type="image" :filesData="formData.media" />
                </b-tabs>
                <button class="btn ripple btn-main-primary mt-2" :disabled="buttonDisable" :class="buttonDisable ? 'button-readonly' : ''">Submit</button>
              </ValidationObserver>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import ImageUpload from '../../../components/ImageUpload'
const page = 'hotel'
export default {
  name: 'HotelAdd',
  data () {
    return {
      ckEditorConfig: {
        contentsLangDirection: 'ru',
        filebrowserImageUploadUrl: `${process.env.VUE_APP_WEB_API}editor/upload`,
        fileTools_requestHeaders: {
          'X-Requested-With': 'XMLHttpRequest',
          Authorization: `Bearer ${localStorage.access_token}`
        }
      },
      map: {
        position: { lat: 51.093048, lng: 6.842120 },
        center: { lat: 51.093048, lng: 6.842120 },
        zoom: 8
      },
      page: page,
      showVideo: false,
      isEdit: false,
      buttonDisable: false,
      multipleFiles: [],
      districts: [],
      facilities: [],
      formData: {
        house_rules: [{
          title: {},
          body: {}
        }],
        title_l: {},
        geo: {
          latitude: 51.093048,
          longitude: 6.842120
        }
      },
      isCreate: false,
      cookieId: ''
    }
  },
  computed: {
    ...mapState({
      languages: state => state.language.languages,
      itemData: state => state[page].itemData
    })
  },
  components: {
    ImageUpload
  },
  created () {
    this.cookieId = this.$route.params.id
    if (this.cookieId === 'add') {
      this.isEdit = false
      this.isCreate = true
      this.showVideo = true
    } else {
      this.isEdit = true
      this.getData({ id: this.cookieId }).then(res => {
        this.showVideo = true
        this.formData = this.itemData
        this.changeAddress({
          lat: +this.formData.geo.latitude,
          lng: +this.formData.geo.longitude
        }, 17)
      })
    }
    this.getCreateData().then((res) => {
      this.districts = res.districts
      this.facilities = res.facilities
    })
  },
  methods: {
    ...mapActions({
      create: page + '/create',
      update: page + '/update',
      getCreateData: page + '/getCreateData',
      getData: page + '/getData'
    }),
    addContent () {
      this.formData.house_rules.push({
        title: {},
        body: {}
      })
    },
    removeContent (i) {
      this.formData.house_rules.splice(i, 1)
    },
    customLabel (data) {
      return `${data.title_l[this.$i18n.locale]}`
    },
    dragendMapMarker (place) {
      this.formData.address = place.formatted_address
      this.changeAddress({
        lat: place.latLng.lat(),
        lng: place.latLng.lng()
      })
      this.$refs.autocomplete.$el.value = ''
    },
    searchAddressDone (place) {
      this.formData.address = place.formatted_address
      this.changeAddress({
        lat: place.geometry.location.lat(),
        lng: place.geometry.location.lng()
      }, 17)
    },
    changeAddress (place, zoom = null) {
      this.map.center = place
      this.map.position = place
      if (zoom) { this.map.zoom = zoom }
    },
    checkValidation (data) {
      return data
    },
    formSubmit () {
      this.$refs.currencyAddForm.validate().then(success => {
        if (success) {
          this.buttonDisable = true
          const form = document.getElementById('hotelsAddForm')
          const formData = new FormData(form)
          if (this.formData.house_rules && this.formData.house_rules.length) {
            this.formData.house_rules.map((item, index) => {
              Object.entries(item.body).map(([code, val], i) => {
                formData.append(`house_rules[${index}][body][${code}]`, val)
              })
            })
          }
          this.multipleFiles.map((item) => {
            formData.append('media[]', item)
          })
          this.formData.facilities.map((item) => {
            formData.append('facilities[]', item.id)
          })
          formData.append('district_id', this.formData.district.id)
          formData.append('address', this.formData.address)
          formData.append('geo[latitude]', this.map.center.lat)
          formData.append('geo[longitude]', this.map.center.lng)
          if (this.isCreate === true) {
            this.create(formData).then(() => {
              this.$toasted.success(this.$t('messages.success.courseCreated')).goAway(1500)
              this.$router.push('/' + page)
            }).catch(() => {
              this.$toasted.error(this.$t('messages.error.somethingWentWrong')).goAway(1500)
            }).finally(() => {
              this.buttonDisable = false
            })
          } else {
            formData.append('_method', 'PUT')
            this.update({ data: formData, id: this.$route.params.id }).then(res => {
              this.$toasted.success(this.$t('messages.success.courseUpdated')).goAway(1500)
              this.$router.push('/' + page)
            }).catch(() => {
              this.$toasted.error(this.$t('messages.error.somethingWentWrong')).goAway(1500)
            }).finally(() => {
              this.buttonDisable = false
            })
          }
        } else {
          this.$toasted.error(this.$t('messages.error.validationError')).goAway(1500)
        }
      })
    }
  }
}
</script>
